var Fraction = window.Fraction = window.Fraction || {};

import Dispatcher from './fraction/dispatcher';
import Analytics from './fraction/analytics';

Fraction.setupContext = (user) => {
  user = user || Fraction.User || {identifier: ""};
}

Fraction.setupContext();

var i18n = window.i18n = require('./i18n');
i18n.init('/locales/');
window.brands = require('./brands');

Fraction.Helpers        = require('./fraction/helpers');
Fraction.Library        = require('./fraction/components/library/container');
Fraction.Reader         = require('./fraction/components/reader/container');
Fraction.Assignments    = require('./fraction/components/gadgets/src/assignments/books/assignment-books');
Fraction.UserPage       = require('./fraction/components/user/container');
Fraction.Error          = require('./fraction/components/helpers/error-container');
Fraction.Redirect       = require('./fraction/components/helpers/redirect-container');
Fraction.Router         = require('./fraction/routes');
Fraction.Reporter       = Analytics;
Fraction.Loading        = require('./fraction/components/layouts/loading-container').default;
require('./fraction/preload');
// require('./fraction/recaptcha');
Fraction.Data           = {};  // must be defined or everything breaks

// import React from 'react';
import App from './app';
Fraction.App = App;
// import ReactDOM from 'react-dom';

;(function(){
  $(document).ready(function(){
    // can't initialize the Router here because it's loaded via JSX
    // and who knows when that actually happens

    // http://stackoverflow.com/questions/18000090/no-outline-on-mouse-focus-but-still-have-outline-on-keyboard-focus
    $("body").on("mousedown", "*", function(e) {
      if (($(this).is(":focus") || $(this).is(e.target) || $(this).children().is(e.target)) && $(this).css("outline-style") === "none") {
        $(this).css("outline", "none").on("blur", function() {
          $(this).off("blur").css("outline", "");
        });
      }
    });

    //ReactDOM.render(<App />, document.getElementById('bookshelf'));
  });

  Fraction.Reporter.flushEvents();
  setInterval(function(){ Fraction.Reporter.flushEvents(); }, 5000);


  // Initialize Configuration

  window.onerror = function(msg, url, line, col, error) {
    /*console.log(msg);
    console.log(url);
    console.log(line);
    console.log(col);
    console.log(error);*/
    //Fraction.Router.setRoute('/system-error')
  };

  // function that recaptcha library will call if loaded
  window.recaptchaLoadCallback = function() {
    const renderRecaptcha = function(sitekey, stoken){
      window.grecaptcha.render('g-recaptcha', {
        'sitekey' : sitekey,
        'stoken' : stoken
      });
      Dispatcher.emit(Dispatcher.RECAPTCHA_RENDERED);
    };
    const sitekey = Fraction.Helpers.getParameterByName("captcha_key");
    const stoken = Fraction.Helpers.getParameterByName("captcha_token");
    if (sitekey && stoken) {
      renderRecaptcha(sitekey, stoken);
    } else {
      Jigsaw.User.generateCaptcha((response) => {
        renderRecaptcha(response.data.captcha_key, response.data.captcha_token);
      });
    }
  };
  window.recaptchaExpiredCallback = function(e) {
    var old = document.getElementById('g-recaptcha');
    old.parentNode.insertBefore(old.cloneNode(), old.nextSibling);
    old.remove();
    window.recaptchaLoadCallback();
  };
  window.recaptchaErrorCallback = function(e) {
  };
}).call(this);
